import { pageService } from "front-end/components/page/page.service";

export class FormScrollService {
    private _currentContext: JQuery = $();
    private _errors: JQuery = $();
    private _submitMessage: JQuery = $();
    private _submitMessageHtml: JQuery = $();
    private _isFormSubmitted: boolean = false;

    private _classMap = {
        error: ".field-validation-error",
        submitMessage: ".umbraco-forms-submitmessage",
        submitMessageHtml: ".umbraco-forms-submitmessage-html",
        formSubmitted: "#ina-umbraco-forms-form-submitted"
    };

    private scrollToFormTarget(): void {
        if (!this._isFormSubmitted) {
            return;
        }

        if (this._errors.length) {
            pageService.scroll(this._errors);
            return;
        }

        if (this._submitMessage.length) {
            pageService.scroll(this._submitMessage);
            return;
        }

        if (this._submitMessageHtml.length) {
            pageService.scroll(this._submitMessageHtml);
            return;
        }

        pageService.scroll(this._currentContext);
    }

    private parseContext(): void {
        this._isFormSubmitted = $(this._classMap.formSubmitted, this._currentContext).length > 0;
        this._errors = $(this._classMap.error, this._currentContext);
        this._submitMessage = $(this._classMap.submitMessage, this._currentContext);
        this._submitMessageHtml = $(this._classMap.submitMessageHtml, this._currentContext);
    }

    public init($context: JQuery): void {
        this._currentContext = $context || this._currentContext;

        this.parseContext();
        this.scrollToFormTarget();
    }
}
